const MAX_LENGTH_CONSTRAINTS = {
  PICKUP_PRO_FORM: {
    ZIP: 6,
    CONSIGNEE_NAME: 30,
    CONSIGNEE_CITY: 20,
    PIECES: 5,
    WEIGHT: 7,
    HAZMAT_WEIGHT: 6,
    EXCESSIVE_LENGTH: 2,
  },
  NO_FREIGHT_FORM: {
    CUSTOMER_NAME: 30,
  },
  DELIVERY_PRO_FORM: {
    DE_COMMENTS: 35,
    PALLET_COUNT: 3,
    SCAC_CODE: 5,
    RECEIVER_NAME : 30,
    RECEIVER_EMAIL : 50,
    ADE_NUMBER: 20,
  },
  SHRINK_WRAP: 999,
  PAYMENT_TYPE: {
    CHECK: 10,
  },
  END_TRIP_FORM: {
    DOOR_OR_YARD: 3,
  }
};

const MAX_VALUE_CONSTRAINTS = {
  PICKUP_PRO_FORM: {
    ZIP: 999999,
    PIECES: 99999,
    HU: 99999,
    WEIGHT: 9999999,
    HAZMAT_WEIGHT: 999999,
  },
  DELIVERY_PRO_FORM: {
    PALLET_COUNT: 999,
    ADE_NUMBER: 999999999,
    SCAC_CODE: 9999999999,
    DE_PIECES: 99999,
  },
  END_TRIP_FORM: {
    ODOMETER_READING: 9999999,
    DOOR_OR_YARD: 999,
  },
  EXCESSIVE_LENGTH:{
    INCHES : 11
  }
};

const SPECIAL_SYMBOLS = {
  HAZMAT: "X",
};

const MIN_VALUE = {
  PICKUP_PRO_FORM: {
    WEIGHT: 1,
    PIECES: 1,
    HU: 1,
  },
  DEFAULT: 0,
  DELIVERY_PRO_FORM: {
    ADD_PRO: 1,
    ADE_NUMBER: 1,
    DE_PIECES: 1,
  },
  EXCESSIVE_LENGTH: {
    FEET : 8,
    INCHES : 0
  },
};
const HAZMAT_FORM_CONSTANTS = {
  UN_NUMBER: {
    ERROR_TEXTS: {
      UN_NUMBER_LENGTH_TEXT: "Enter a 4 digit number",
      UN_NUMBER_INVALID_TEXT: "The entered UN number is invalid",
      UN_NUMBER_REQUIRED_TEXT: "UN number is required",
      UN_NUMBER_NOT_SHIPPABLE_TEXT:
        "We does not ship this product. Return this item to shipper",
    },
    WARNING_TEXTS: {
      UN_NUMBER_WARNING_TEXT: "Invalid entry",
    },
  },
  WEIGHT_ERROR_TEXT:
    "Hazmat weight cannot be greater than total weight of the bill",
  BULK_LIST: [
    {
      value: false,
      label: "No",
    },
    {
      value: true,
      label: "Yes",
    },
  ],
  PG_NUMBER_LIST: [
    { label: "None", value: "" },
    { label: "I", value: "I" },
    { label: "II", value: "II" },
    { label: "III", value: "III" },
  ],
  UN_PREFIX: "UN",
};

const PAYMENT_MODES = {
  FREIGHT_PAYMENT_MODES: {
    CASH: "cash",
    CHECK: "check",
    COMPANY_ACCOUNT: "companyAccount",
    FREIGHT_PAYMENT_MODELIST: [
      { description: "Cash", code: "cash" },
      { description: "Check", code: "check" },
      { description: "Company Account", code: "companyAccount" },
    ],
  },
  COD_PAYMENT_MODES: {
    CERTIFIED_CHECK: "certifiedCheck",
    COMPANY_CHECK: "companyCheck",
    COD_PAYMENT_MODELIST: [
      { description: "Certified Check/ Money Order", code: "certifiedCheck" }, // Money Order
      { description: "Company Check", code: "companyCheck" },
    ],
  },
};

const CUSTOMER_CONFIG = {
  SAIA: "SAIA",
  DEFAULT: "DEFAULT",
  SMT : "SMT",
  RRTS : "RRTS",
  ESTES: "ESTES",
  SEFL: "SEFL",
  TSTCF: "TSTCF"
};

const EXCEPTION_FLOW = {
  ADE :"ADE",
  DEFAULT: "DEFAULT",
  BOTH: "BOTH"
}

const EXCEPTION_CODE = {
    DELIVERY_DAMAGED:"DD",
    DELIVERY_SHORT:"DS",
    DELIVERY_OVER:"DO",
    PARTIALLY_REFUSED:"PR"
}

const EXCEPTION_NUMBER_LABEL = {
  EA_NUMBER: "EA Number",
  ADE_NUMBER: "ADE Number"
}

const EXCEPTION_NUMBER_VALIDATION = {
  DEFAULT_MIN_LENGTH: 8,
  DEFAULT_MAX_LENGTH: 8
}

export {
  MAX_LENGTH_CONSTRAINTS,
  HAZMAT_FORM_CONSTANTS,
  PAYMENT_MODES,
  MIN_VALUE,
  MAX_VALUE_CONSTRAINTS,
  SPECIAL_SYMBOLS,
  CUSTOMER_CONFIG,
  EXCEPTION_CODE,
  EXCEPTION_FLOW,
  EXCEPTION_NUMBER_LABEL,
  EXCEPTION_NUMBER_VALIDATION,
};
